export const COLOR = {
  bg: "#000000",
  main_yellow: `#F7B826`,
  active_yellow: `#F7B826`,
  main_grey: `#DADADA`,
  btn_grey: `#818181`,
  border_grey: `#2c2c2c`,
  gender_blue: `#3257B5`,
  gender_pink: `#F17474`,
};
